module.exports = __webpack_public_path__ + "img/lock.72496fed.svg";